export default {
  title: '',//页面头部标题
  type: '', // 弹出类型
  callback: '', // 回调函数
  message: '', // 提示内容
  httpLoading:false,//请求loading
  showTransfer:null,
  router: ['index'], // 缓存的路由name
  platform: 'wechat', // 来自于哪个平台 ios android webApp wechat[default]
  signature: {
    app_id: 'null',
    jsapi_ticket: 'null'
  }, // 微信签名配置
  user_id:0,//推荐人id
}



// WEBPACK FOOTER //
// ./src/store/system/state.js